import { tsUtils } from '@neo-one/ts-utils';
import { Types } from '../../../constants';
import { BuiltinInstanceMemberCall } from '../../BuiltinInstanceMemberCall';
export class ArrayStoragePop extends BuiltinInstanceMemberCall {
    canCall() {
        return true;
    }
    emitCall(sb, func, node, optionsIn, visited) {
        const options = sb.pushValueOptions(optionsIn);
        if (!visited) {
            sb.visit(tsUtils.expression.getExpression(func), options);
        }
        sb.emitOp(node, 'DUP');
        sb.emitHelper(node, options, sb.helpers.getArrayStorageLength);
        sb.emitHelper(node, options, sb.helpers.if({
            condition: () => {
                sb.emitOp(node, 'DUP');
                sb.emitPushInt(node, 0);
                sb.emitOp(node, 'NUMEQUAL');
            },
            whenTrue: () => {
                sb.emitOp(node, 'DROP');
                sb.emitOp(node, 'DROP');
                if (optionsIn.pushValue) {
                    sb.emitHelper(node, options, sb.helpers.wrapUndefined);
                }
            },
            whenFalse: () => {
                sb.emitHelper(node, options, sb.helpers.if({
                    condition: () => {
                        sb.emitOp(node, 'DUP');
                        sb.emitPushInt(node, 1);
                        sb.emitOp(node, 'NUMEQUAL');
                    },
                    whenTrue: () => {
                        sb.emitOp(node, 'DROP');
                        sb.emitPushInt(node, 0);
                    },
                    whenFalse: () => {
                        sb.emitOp(node, 'DEC');
                    },
                }));
                sb.emitOp(node, 'SWAP');
                sb.emitOp(node, 'TUCK');
                sb.emitOp(node, 'OVER');
                sb.emitHelper(node, options, sb.helpers.wrapNumber);
                if (optionsIn.pushValue) {
                    sb.emitOp(node, 'SWAP');
                    sb.emitOp(node, 'TUCK');
                    sb.emitOp(node, 'OVER');
                    sb.emitHelper(node, options, sb.helpers.getStructuredStorage({
                        type: Types.ArrayStorage,
                        keyType: undefined,
                        knownKeyType: Types.Number,
                    }));
                    sb.emitPushInt(node, 5);
                    sb.emitOp(node, 'XTUCK');
                    sb.emitOp(node, 'DROP');
                }
                sb.emitHelper(node, sb.noPushValueOptions(options), sb.helpers.deleteStructuredStorage({
                    type: Types.ArrayStorage,
                    keyType: undefined,
                    knownKeyType: Types.Number,
                }));
                sb.emitHelper(node, options, sb.helpers.putArrayStorageLength);
            },
        }));
    }
}

//# sourceMappingURL=pop.js.map
